// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"544bedf8","519":"4bf2f4d7"}[chunkId] + ".chunk.js";
};